import { IonDate } from "../components/IonDate";
const CheckNotNull = Symbol("CheckNotNull");

class EventRegistrationReferral {
    public event_regRefID: string = '';
    public event_registrationID: string = '';
    public userID: string = '';
    public public_beneficiary_id: string = '';
    public public_beneficiary_fullname: string = '';
    public public_beneficiary_email: string = '';
    public public_beneficiary_phone: string = '';
    public datetime_created: Date | null = null;
    public datetime_expired: Date | null = null;

    constructor(
        event_regRefID: string,
        event_registrationID: string,
        userID: string,
        public_beneficiary_id: string,
        public_beneficiary_fullname: string,
        public_beneficiary_email: string,
        public_beneficiary_phone: string,
        datetime_created: string,
        datetime_expired: string
    ) {
        this.event_regRefID = this[CheckNotNull](event_regRefID) ? event_regRefID : '';
        this.event_registrationID = this[CheckNotNull](event_registrationID) ? event_registrationID : '';
        this.userID = this[CheckNotNull](userID) ? userID : '';
        this.public_beneficiary_id = this[CheckNotNull](public_beneficiary_id) ? public_beneficiary_id : '';
        this.public_beneficiary_fullname = this[CheckNotNull](public_beneficiary_fullname) ? public_beneficiary_fullname : '';
        this.public_beneficiary_email = this[CheckNotNull](public_beneficiary_email) ? public_beneficiary_email : '';
        this.public_beneficiary_phone = this[CheckNotNull](public_beneficiary_phone) ? public_beneficiary_phone : '';
        this.datetime_created = this[CheckNotNull](datetime_created) ? IonDate(datetime_created) : null;
        this.datetime_expired = this[CheckNotNull](datetime_expired) ? IonDate(datetime_expired) : null;
    }

    private [CheckNotNull] = (value: string) => {
        if(value && value != null && value != 'null' && value.length > 0)
            return true;
        else
            return false;
    }

} export default EventRegistrationReferral;